import {GetOnePublicDraftCommand, type GetOnePublicDraftResponse} from '@perfectpost/perfect-post-common';
import {skipToken, useQuery} from '@tanstack/react-query';

import {sendOrThrow} from '../../../services/sendOrThrow';
import {draftKeys} from '../keys';

/**
 * Un brouillon partagé publiquement, lu sans session.
 *
 * Remplace le `send(new GetOnePublicDraftCommand(id))` écrit dans un
 * `useEffect` + `useState` de `DraftSharing`. Clé à part de `list()` et
 * `detail()` : ce document n'appartient pas forcément à l'utilisateur.
 */
export function usePublicDraftQuery(draftId: string | undefined) {
  return useQuery({
    queryKey: draftKeys.publicDetail(draftId),
    queryFn:
      draftId === undefined
        ? skipToken
        : (): Promise<GetOnePublicDraftResponse> => sendOrThrow(new GetOnePublicDraftCommand(draftId)),
  });
}
